<template>
<v-container fluid>
    <v-dialog v-model="createOfferDialog" persistent content-class="rounded-lg" max-width="550">
        <v-card class="px-3">
            <v-form v-model="createValid" ref="createForm" @submit.prevent="submitOffer()">
                <v-card-title class="pb-5">
                    {{ $t('PriceOfferPage.create-offer') }}
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col class="py-2 px-1" cols="6">
                            <v-autocomplete 
                                v-model="offer_template.account_id"
                                :items="configs.accounts.filter(c => c.type === type.sub)"
                                item-text="name"
                                item-value="id"
                                :rules="[v => !!v]"
                                dense
                                outlined
                                hide-details
                                :label="$t('PriceOfferPage.account')"
                            />
                        </v-col>
                        <v-col class="py-2 px-1" cols="6">
                            <bee-date-picker
                                v-model="offer_template.date"
                                ref="dateEdit"
                                context="invoice"
                                :action-name="actions.EDIT"
                                :label="$t('PriceOfferPage.offer-date')"
                                :hide-details="true"
                            />
                        </v-col>
                        <v-col v-if="!isWarehousePermission && useChangeCurrency" cols="12" lg="6" class="px-1">
                            <v-autocomplete
                                v-model="offer_template.alternative_currency_id"
                                :items="configs.currencies"
                                :label="currencyNameCreate"
                                item-value="id"
                                item-text="symbol"
                                dense
                                hide-details
                                outlined
                                class="rounded-lg"
                                @change="recommendCurrencyPriceCreate(offer_template.alternative_currency_id)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col v-if="!isWarehousePermission && useChangeCurrency" cols="12" lg="6"  class="px-1">
                            <v-text-field
                                v-model="offer_template.currency_price"
                                dense
                                hide-details
                                outlined
                                :disabled="disableDefaultCurrencyPriceCreate"
                                :label="$t('change-currency.currency-value')"
                                class="rounded-lg"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col class="py-2 px-1" cols="6">
                            <v-text-field
                                v-model="offer_template.validity_days"
                                :label="$t('PriceOfferPage.validity-days')"
                                outlined
                                hide-details
                                dense
                            />
                        </v-col>
                        <v-col class="py-2 px-1" cols="6">
                            <v-text-field
                                v-model="offer_template.payment_terms"
                                :label="$t('PriceOfferPage.payment-terms')"
                                outlined
                                dense
                                hide-details
                                required
                            />
                        </v-col>
                        
                        <v-col class="py-2 px-1" cols="12">
                            <v-text-field
                                v-model="offer_template.notes"
                                :label="$t('PriceOfferPage.notes')"
                                outlined
                                dense
                                hide-details
                                required
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pb-3">
                        <v-btn type="submit" :loading="createLoading" color="success" text>{{$t('buttons.create')}}</v-btn>
                        <v-btn color="red" :disabled="createLoading" text @click="createOfferDialog = false; reset()">{{$t('buttons.cancel')}}</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
        <!-- chang currency alert dialog -->
    <v-dialog 
        v-model="changeCurrencyAlertDialog"
        width="400"
        persistent
        
    >
        <v-card class="rounded-lg">
            <v-card-title>
                {{ $t('change-currency-alert.dialog-header') }}
            </v-card-title>
            <v-card-text class="pb-1">
                {{ $t('change-currency-alert.can-not-change-currency') }}
            </v-card-text>
            <v-card-actions>
                <v-btn
                    @click="changeCurrencyAlertDialog = false"
                    color="transparent grey--text"
                    depressed
                >
                    {{ $t('close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- delete dialog -->
    <v-dialog v-model="deleteDialog" width="450px">
        <v-card>
            <v-card-title>
                {{$t('PriceOfferPage.price-offer-delete')}}
            </v-card-title>
            
            <v-card-text class="py-2">
                {{$t('PriceOfferPage.are-you-sure-of-delete-price-offer')}}
            </v-card-text>

            <v-card-actions>
                <v-btn text color="success-color" @click="deleteOffer($route.params?.id)">{{$t('buttons.ok')}}</v-btn>
                <v-btn text color="danger-dark-color" @click="deleteDialog = false">
                    {{$t('buttons.cancel')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog
        v-model="currentCurrencyDialog"
        width="400"
        persistent
    >
        <v-card class="rounded-lg">
            <v-card-title>
                {{ $t('PriceOfferPage.change-offer-currency') }}
            </v-card-title>
            <v-card-text class="pb-1 pt-2">
                <div>
                    <v-row dense>
                        <v-col cols="12" lg="6">
                            <v-autocomplete
                                v-model="offer_data.alternative_currency_id"
                                :items="configs.currencies"
                                item-value="id"
                                item-text="symbol"
                                dense
                                hide-details
                                outlined
                                :label="currencyNameUpdate"
                                class="rounded-lg"
                                @change="recommendCurrencyDefaultPriceUpdate(offer_data.alternative_currency_id)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-text-field
                                v-model.number="offer_data.currency_price"
                                dense
                                hide-details
                                outlined
                                :disabled="disableDefaultCurrencyPrice"
                                :label="$t('change-currency.currency-value')"
                                class="rounded-lg"
                                type="number"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="transparent warning--text"
                    depressed
                    :loading="changeCurrencyLoading"
                    @click="submitOffer(true)"
                >
                    {{ $t('change') }}
                </v-btn>
                <v-btn
                    @click="currentCurrencyDialog = false; resetCurrencyDialog()"
                    color="transparent red--text"
                    depressed
                >
                    {{ $t('cancel') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-row  dense class="mb-0 pb-0 ">
        <v-col cols="12" lg="auto">
            <slot name="breadcrumbs" :item="true"></slot>
        </v-col>
        <v-col cols="auto" class="d-flex">
            <bee-bond-up-down
                v-model="offer_no"
                :label="$t('PriceOfferPage.offer-no')"
                :disabled="loading || !offers.length"
                class="medium-placeholder"
                :items="offers?.map(c => c.no)"
                @keydown-enter-prevent="updateRouteId()"
                @programmatically-changed="updateRouteId()"
            ></bee-bond-up-down>
        </v-col>
        <v-col cols="auto">
            <v-btn
                color="success white--text"
                :disabled="isViewer || loading"
                class="mx-2"
                @click="createOfferDialog = true; recommendDefaultCurrencyCreate()"
            >
                <v-icon> mdi-plus </v-icon>
                {{$t('buttons.new')}}
            </v-btn>
        </v-col>
        <v-col cols="auto"  v-if="$route.params.id">
            <v-btn
                :disabled="isViewer || loading"
                color="danger-color"
                dark
                @click="deleteDialog = true"
            >
                <v-icon>
                    mdi-delete
                </v-icon>
                {{$t('buttons.delete')}}
            </v-btn
            >
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto">
            <v-menu offset-y>
                <template v-slot:activator="{ attr, on }">
                    <v-btn dark color="alert-color" v-on="on" v-bind="attr">
                        <v-icon class="me-1">mdi-export-variant</v-icon>
                        {{$t('exports.export')}}
                    </v-btn>
                </template>

                <v-list nav dense>
                    <v-list-item @click="createReport()">
                        <v-list-item-icon class="me-4">
                            <v-icon>mdi-printer</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{$t('exports.export-as-pdf')}}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-col>
    </v-row>
    <v-row dense class=" mx-0 px-0 py-1 mb-2 my-border rounded-lg" >
        <v-col cols="auto" class="d-flex align-center">
            <bee-date-picker
            v-model="offer_data.date"
            ref="dateEdit"
            context="invoice"
            :action-name="actions.EDIT"
            :disabled="offer.status !== offerStatus.draft"
            :label="$t('PriceOfferPage.offer-date')"
            :rules="[
            ]"
            :hide-details="true"
            @blur="submitOffer(true)"
        ></bee-date-picker>
        </v-col>
        <v-col cols="6" sm="4" md="2" lg="2" class="px-1">
            <v-autocomplete 
                v-model="offer_data.account_id"
                :items="configs.accounts.filter(c => c.type === type.sub)"
                item-text="name"
                item-value="id"
                :disabled="offer.status !== offerStatus.draft"
                dense
                outlined
                hide-details
                :label="$t('PriceOfferPage.account')"
                @change="submitOffer(true)"
            />
        </v-col>
        <!-- warehouse -->
        <v-col lg="2" md="3" sm="4" cols="6">
            <v-autocomplete
                v-model="offer_data.warehouse_id"
                :items="
                    userTypePermission === userType.warehouseKeeper && multipleWarehouses
                        ? warehousesForKeeper
                        : warehouses
                "
                :item-value="
                    userTypePermission === userType.warehouseKeeper && multipleWarehouses
                        ? 'warehouse_id'
                        : 'id'
                "
                :item-text="
                    userTypePermission === userType.warehouseKeeper && multipleWarehouses
                        ? 'warehouse_name'
                        : 'name'
                        "
                :label="$t('inputs.warehouse')"
                :disabled="offer.status !== offerStatus.draft"
                dense
                outlined
                hide-details
                @change="setWarehouse()"
            ></v-autocomplete>
        </v-col>
        
        <!-- material -->
        <v-col  lg="2" md="3" sm="4" cols="6">
            <v-autocomplete
                v-model="offer_data.material_id"
                :label="$t('inputs.material')"
                :item-text="c => `${c.no} - ${c.name}`"
                :items="materialsFilter(offer_data.warehouse_id, type.main)"
                item-value="id"
                dense
                :disabled="!offer_data.warehouse_id || offer.status !== offerStatus.draft"
                outlined
                hide-details
                clearable 
                @change="filteredMaterials = [];getNodeMaterials()"
            >
                <template v-slot:item="data">
                    <v-list-item
                        class="py-1"
                        :class="type.main === data.item.type ? 'orangeLighten5': 'none'"
                        v-on="data.on"
                        v-bind="data.attrs"
                    >
                        <div>
                        {{ data.item.no + '-'+ data.item.name }}
                        </div>

                    </v-list-item>
                </template>
            </v-autocomplete>
        </v-col>
        <v-col  cols="6" sm="4" md="2" lg="2" >
            <v-text-field 
                v-model="offer_data.notes"
                :label="$t('inputs.notes')"
                outlined
                :disabled="offer.status !== offerStatus.draft"
                dense
                hide-details
                @change="submitOffer(true)"
            />
        </v-col>
        <v-col cols="6" sm="4" md="1" class="px-0">
            <v-autocomplete
                v-model="offer_data.status"
                :label="$t('inputs.status')"
                :items="offerStatuses"
                item-text="name"
                item-value="id"
                dense
                outlined
                hide-details
                @change="changeOfferStatus(true)"
            >

            </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="auto" xs="auto" md="auto" lg="auto" class="d-flex align-center justify-center px-1" v-if="!isWarehousePermission && useChangeCurrency">
            <v-tooltip bottom content-class="rounded-lg">
                <template v-slot:activator="{ on, attr }">
                    <v-btn
                        v-bind="attr"
                        v-on="on"
                        :disabled="offer.status !== offerStatus.draft"
                        icon
                        @click="recommendDefaultCurrency();currentCurrencyDialog = true;"
                    >
                        <v-icon>
                            mdi-cash-multiple
                        </v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('change-currency.change-invoice-currency') }}</span>
            </v-tooltip>
            <span class="grey--text text--darken-2" v-if="!isWarehousePermission && useChangeCurrency">
                {{configs.currencies.find(c => c.id === (offer.alternative_currency_id ? offer.alternative_currency_id : currentFinancialFile.default_currency_id)).symbol}}
            </span>
        </v-col>
        <!-- <v-spacer></v-spacer> -->
    </v-row>
    <bee-handy-smart-table 
        ref="table"
        v-model="tableInputs"
        :headers="headers"
        :items="entries || []"
        :loading="loading"
        fixed-header
        dense
        zebra
        hot-inputs="lazy"
        :height="$vuetify.breakpoint.height - (offer.alternative_currency_id ? 315 : 300)"
        :context-menu-items="contextMenuItems"
        :scroll-to-row-expression="(item) => item.id === entries[entries.length - 1]?.id"
        :items-per-page="-1"
        hide-inputs-details
        hide-no-data-area
        :show-add-row="$route.params.id && offer.status === offerStatus.draft"
        :disable-input-fields="loading"
        with-columns-divider
        :editable-rows="offer.status === offerStatus.draft"
        :disable-context-menu="offer.status !== offerStatus.draft"
        hide-default-footer
        @context-menu-edit="({ index, item }) => setRowIndexBeforeEdit(index,item)"
        @context-menu-delete="({ item }) => { rowId = item.id; deleteEntry()}"
        @keypress.enter="entryHandler"
    >
        <template v-slot:input.warehouseId="{ attr, on }">
            <v-autocomplete
                v-on="on"
                v-bind="attr"
                @change="tableInputs.materialId = null"
                :items="
                    userTypePermission === userType.warehouseKeeper && multipleWarehouses
                        ? warehousesForKeeper
                        : warehouses
                "
                :item-value="
                    userTypePermission === userType.warehouseKeeper && multipleWarehouses
                        ? 'warehouse_id'
                        : 'id'
                "
                :item-text="
                    userTypePermission === userType.warehouseKeeper && multipleWarehouses
                        ? 'warehouse_name'
                        : 'name'
                "
            />
        </template>
        <template v-slot:input.materialId="{ attr, on }">
            <!-- <bee-material-autocomplete
                class="mb-1"
                v-on="on"
                v-bind="attr"
                :inside-table="true"
                :with-balance="true"
                :items="warehouseId !== tableInputs.warehouseId 
                            ? materials.filter(v => v.warehouse_id === tableInputs.warehouseId && v.type === type.sub)
                            :filteredMaterials.length 
                                ? filteredMaterials.filter(v => v.type === type.sub) 
                                : materials.filter(v => v.type === type.sub)"
            /> -->
            <v-autocomplete
                v-on="on"
                v-bind="attr"
                class="mb-3"
                :items="offer_data.warehouse_id !== tableInputs.warehouseId 
                            ? materialsFilter(tableInputs.warehouseId, type.sub)
                            :filteredMaterials.length
                                ? filteredMaterials.filter(v => v.type === type.sub) 
                                : materialsFilter(null,type.sub)"
                :item-text="c => `${c.no} - ${c.name}`"
                item-value="id"
                hide-details
                @change="recommendMaterialData()"
            >
                <template v-slot:item="data">
                    <v-list-item
                        :class="type.main === data.item.type ? 'orangeLighten5': 'none'"
                        v-on="data.on"
                        v-bind="data.attrs"
                    >
                        <div class="d-flex flex-column py-1">
                            <span>
                                {{ data.item.no + '-'+ data.item.name }}
                            </span>
                        </div>
                        <v-spacer></v-spacer>
                        <bee-material-amount-label :with-color="true" :value="data.item.balance" :show-zeros-values="true"></bee-material-amount-label>

                    </v-list-item>
                </template>
            </v-autocomplete>
        </template>
        <template v-slot:item.discount-percentage="{ item }">
            % {{ item.discount_percentage ? item.discount_percentage : '-' }}
        </template>
        <template v-slot:item.hint="{ item, index }" v-if="offer.status === offerStatus.draft">
            <div class="text-center">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attr }">
                        <v-btn
                            small
                            icon
                            v-bind="attr"
                            v-on="on"
                            width="32"
                        >
                            <v-icon>
                                mdi-dots-vertical
                            </v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item @click="setRowIndexBeforeEdit(index,item)">
                            <v-list-item-content class="pa-0">
                                {{ $t('buttons.edit') }}
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="rowId = item.id; deleteEntry()">
                            <v-list-item-content class="pa-0">
                                {{ $t('buttons.delete') }}
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
        </template>
        <template v-slot:footer="{}">
            <v-row>
                <v-col></v-col>
                <v-col cols="4" class="d-flex align-center px-5">
                    <p class="my-0 mx-1">
                        {{ $t('PriceOfferPage.total-price') }}:
                    </p>
                    <span >
                        {{ offer_data.total_price.toLocaleString('en') }}
                        {{ getCurrencyById(offer.alternative_currency_id || configs.financial_file.default_currency_id)?.symbol }}
                    </span> 
                </v-col>
            </v-row>
        </template>
    </bee-handy-smart-table>
    <v-footer id="footer" fixed app horizontal background-color="#E1E1E1" class="px-4">
        <div class="d-flex py-2" style="width: 100%;">
            <v-row class="d-flex">
                <v-col cols="2" sm="4" md="2" lg="2"  class="d-flex align-center">
                    <v-text-field
                        v-model="offer_data.payment_terms"
                        :label="$t('PriceOfferPage.payment-terms')"
                        outlined
                        :disabled="offer.status !== offerStatus.draft"
                        dense 
                        hide-details
                        @change="submitOffer(true)"
                    >

                    </v-text-field>
                </v-col>
                <v-col cols="2" class="d-flex align-center">
                    <v-text-field
                        v-model="offer_data.validity_days"
                        :label="$t('PriceOfferPage.validity-days')"
                        outlined
                        :disabled="offer.status !== offerStatus.draft"
                        dense
                        hide-details
                        @change="submitOffer(true)"
                    >
                    </v-text-field>
                </v-col>

                <v-spacer></v-spacer>
                <v-col cols="2" class="d-flex align-center">
                    <v-text-field
                        v-model.number="offer_data.discount_total"
                        :label="$t('PriceOfferPage.discount-total')"
                        type="number"
                        :disabled="offer.status !== offerStatus.draft"
                        outlined
                        dense
                        hide-details
                        @change="submitOffer(true)"
                    >
                        
                    </v-text-field>
                </v-col>
                <!-- <v-col class="d-flex align-center py-2" cols="auto">
                        <p class="blue-grey--text ma-0">{{ $t('PriceOfferPage.total-price') }}</p>
                    <v-card
                    	class="pa-2 d-flex flex-column flex-wrap  align-center justify-center rounded-md mx-1"
                    	height="100%"
                    	width="fit-content"
                    >
                            <span
                                class=" green--text"
                            >
                                {{ offer_data.total_price?.toLocaleString('en') }}
                                {{ getCurrencyById(this.offer.alternative_currency_id || configs.financial_file.default_currency_id)?.symbol }}
                            </span>
                    </v-card>
                </v-col> -->
                <v-col class="d-flex align-center py-2" cols="auto">
                    <p class="blue-grey--text ma-0">{{$t('PriceOfferPage.total-net')}}</p>
                    <v-card
                    	class="pa-2 d-flex flex-column flex-wrap  align-center justify-center rounded-md mx-1"
                    	max-height="120px"
                    	width="fit-content"
                    >
                            <span
                                class=" green--text"
                            >
                                {{ offer_data.total_net?.toLocaleString('en') }}
                                {{ getCurrencyById(configs.financial_file.default_currency_id)?.symbol }}
                            </span>
                            <span
                                v-if="offer.alternative_currency_id"
                                class="green--text"
                            >
                                {{ offer.alternative_total_net?.amount?.toLocaleString('en') }}
                                {{ getCurrencyById(offer.alternative_currency_id)?.symbol }}
                            </span>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </v-footer>
</v-container>
</template>
<script>
import rules from '../../../validation'
import actions from "../../../permissions/actions-names.js"
import EventBus from '@/event-bus'
import { mapState, mapGetters } from 'vuex'
import { userType, paymentType, type, userPermission, offerType, offerStatuses, offerStatus } from '../../../helpers/enums'
import { useChangeCurrency, useConfigInvoicesAccount, canCreateInvoiceWithoutDocNo, useInvoiceCategories, multipleWarehouses } from '@/configs/global'
import ls from '../../../settings/localStorageExtension'
import moment from 'moment'
export default {
    data : () => ({
        accountId: null,
        warehouseId: null,
        materialId: null,
        notes: null,
        date: null,
        offer_template:{
            date: moment().format('YYYY-MM-DD'),
            account_id: null,
            alternative_currency_id: null,
            currency_price: null,
            notes: null,
            validity_days: null,
            payment_terms: null
        },
        price_quote: {},
        offer_data: {
            date: moment().format('YYYY-MM-DD'),
            account_id: null,
            material_id: null,
            warehouse_id: null,
            alternative_currency_id: null,
            currency_price: null,
            notes: null,
            validity_days: null,
            payment_terms: null,
            discount_total: null,
            total_net: 0,
            alternative_total_net: null,
            total_price: 0,
            status: null
        },
        rules,
        actions,
        loading: false,
        useChangeCurrency, 
        multipleWarehouses,
        useConfigInvoicesAccount, 
        canCreateInvoiceWithoutDocNo,
        useInvoiceCategories,
        paymentType,
        userType,
        offerStatuses,
        type,
        default_currency_id: null,
        tableInputs: {},
        valid: true,
        createOfferDialog: false,
        createOfferValid: true,
        filteredMaterials: [],
        offer: {},
        offer_no: null,
        offer_entries: [],
        rowId: null,
        EventBus,
        entries: [],
        deleteDialog: false,
        paymentTerms: null,
        currentCurrencyDialog: false,
        changeCurrencyLoading: false,
        createValid: true,
        createLoading: false,
        changeCurrencyAlertDialog: false,
        offerStatus
    }),
    watch: {
        '$route'(val, oldVal) {
            if(val.params.id) {
                this.fetchOffer(val.params.id);
            } else if (oldVal.params.id && this.offers.find(v => v.id === oldVal.params.id)) {
                this.$router.push({name: 'price-offer', params: {id: oldVal.params.id}});
            }
        }
    },
    computed: {
        ...mapState({
            userTypePermission: state => state.permissions.user_type,
            currentFinancialFile: state => state.financialFiles.current_financial_file,
            configs: state => state.configs.configs,
            defaultFinancialFileAccounts: state => state.configs.default_financial_file_accounts,
            warehousesForKeeper: state => state.permissions.warehousesForKeeper,
            warehouses: state => state.warehouses.warehouses,
            materials: state => state.materials.materials,
            offers : state => state.offers.offers,
        }),
        ...mapGetters({
            isViewer: 'permissions/isViewer',
            getAccountById: 'configs/getAccountById',
            getCurrencyById: 'configs/getCurrencyById',
            getOfferByNo: 'offers/getOfferByNo',
            getMaterialById: 'materials/getMaterialById',
            getWarehouseById: 'warehouses/getById',
            getSettingByKey: 'settings/getSettingByKey'
        }),
        headers () {
            const headers =[
                {
                    text: this.$t('headers.no'),
                    name: 'no',
                    value: 'no',
                    sortable: false,
					width: '80',
                    disableInput: true
                },
                {
                    text: this.$t('inputs.warehouse'),
                    name: 'warehouseId',
                    value: 'warehouse_id',
                    sortable: false,
                    width: '25%',
                    inputRules: [v => !!v],
                    setValueExpr: (val) => this.getWarehouseById(val)?.name
                    // setValueExpr: value =>
                    //     this.warehouses.find(c =>
                    //         c.id === this.materials.find(e => e.id === this.buyStatement?.find(k => k.material_id === value)?.material_id
                    //         )?.warehouse_id)?.
                },
                {
                    text: this.$t('headers.material'),
                    name: 'materialId',
                    value: 'material_id',
                    width: '20%',
                    sortable: false,
                    inputRules: [v => !!v],
                    setValueExpr: val => this.getMaterialById(val)?.name
                },
                this.showMaterialSpecifications ?{
                    text: this.$t('headers.material-specifications'),
                    name: 'material-specifications',
                    value: 'notes',
                    sortable: false,
					width:'20%'
                } : null,
                {
                    text: this.$t('headers.quantity'),
                    name: 'quantity',
                    value: 'quantity.quantity',
                    sortable: false,
					width: '80',
                    inputRules: [v => !!v],
                    setInputExpr: (inputs, activeInput) => {
                        if(inputs['calculated-total-amount'] && inputs['price'] && !inputs.quantity && activeInput !== 'quantity') {
                            return inputs['calculated-total-amount'] / inputs['price'];
                        }
                        return inputs.quantity;
                    }
                },
                {
                    text: this.$t('headers.price'),
                    name: 'price',
                    value: this.offer.alternative_currency_id ? 'alternative_price.amount' :'price.amount',
                    type: 'number-format',
                    sortable: false,
					width: '10%',
                    inputRules: [v => !!v],
                    setInputExpr: (inputs, activeInput) => {
                            if(activeInput === 'price') {
                                if (inputs.price && inputs['discount-percentage'] && inputs['discount-amount']) {
                                    this.tableInputs['discount-amount'] = (inputs['discount-percentage'] * (inputs.price * inputs.quantity)) / 100;
                                    this.tableInputs['calculated-total-amount'] = (inputs.price * inputs.quantity) - inputs['discount-amount']; 
                                    return inputs.price
                                }
                                return inputs.price
                            }
                            return inputs.price
                    },
                },
                {
                    text: this.$t('InvoiceSalePage.headers.discount-percentage'),
                    value: 'discount_percentage',
                    name: 'discount-percentage',
                    type: 'number-format',
                    // width: this.$emerald.ifLang('es', '140px', '6%'),
                    width: 110,
                    sortable: false, 
                    setInputExpr: (inputs, activeInput) => {
                        if(activeInput === 'discount-percentage') {
                            if(inputs['discount-percentage']) {
                                this.tableInputs['discount-amount'] = (inputs['discount-percentage'] * (inputs.price * inputs.quantity)) / 100;
                                this.tableInputs['calculated-total-amount'] =  (inputs.price * inputs.quantity) - inputs['discount-amount'];

                                return inputs['discount-percentage']
                            } else {
                                this.tableInputs['discount-amount'] = (inputs['discount-percentage'] * inputs['calculated-total-amount']) / 100;
                                this.tableInputs['calculated-total-amount'] =  (inputs.price * inputs.quantity) - inputs['discount-amount'];

                                return inputs['discount-percentage']
                            }
                        }
                        return inputs['discount-percentage']
                    },
                },
                {
                    text: this.$t('InvoiceSalePage.headers.discount'),
                    value: this.offer.alternative_currency_id ? 'alternative_discount_amount.amount' :'discount_amount.amount',
                    name: 'discount-amount',
                    type: 'number-format',
                    width: '12%',

                    setInputExpr: (inputs, activeInput) => {
                        if (activeInput === 'discount-amount' && inputs.quantity && inputs.price) {
                            this.tableInputs['discount-percentage'] = (inputs['discount-amount'] * 100) / (inputs.quantity * inputs.price)
                            this.tableInputs['calculated-total-amount'] = (inputs.price * inputs.quantity) - inputs['discount-amount'];
                            return inputs['discount-amount']
                        }
                        return inputs['discount-amount']
                    },
                },
                {
                    text: this.$t('headers.net-amount'),
                    name: 'calculated-total-amount',
                    type: 'number-format',
                    value: this.offer.alternative_currency_id ? 'alternative_calculated_total_amount.amount' :'calculated_total_amount.amount',
                    sortable: false,
                    setInputExpr: (inputs, activeInput) => {
                        if (activeInput === 'calculated-total-amount') {
                            if (inputs.quantity) {
                                if(inputs['discount-percentage'] && inputs.quantity) {
                                    this.tableInputs.price = (inputs['discount-amount'] + inputs['calculated-total-amount']) / inputs.quantity
                                    this.tableInputs['discount-percentage'] = (inputs['discount-amount'] / (inputs.price * inputs.quantity)) * 100
                                    // this.tableInputs['discount-percentage'] = (inputs['discount-amount'] / inputs.price) * 100
                                    return inputs['calculated-total-amount']
                                } else {
                                    this.tableInputs.price = inputs['calculated-total-amount'] / inputs.quantity;
                                    this.$nextTick(() => {
                                        this.tableInputs['calculated-total-amount'] = inputs.quantity * inputs.price;
                                    })
                                }
                            } else {
                                return inputs['calculated-total-amount'];
                            }
                        }
                        // else if (['quantity', 'price'].includes(activeInput)) {
                        //     return inputs.quantity * inputs.price;
                        // } 
                        else if (['quantity', 'price'].includes(activeInput) && !inputs['discount-percentage'] && !inputs['discount-amount']) {
                            return inputs.quantity * inputs.price;
                        } 
                        else if(activeInput === 'quantity') {
                            const newVal = inputs.quantity * inputs.price;
                            this.tableInputs['discount-amount'] = (newVal * inputs['discount-percentage']) / 100;
                            return newVal - inputs['discount-amount'];
                        }
                        else {
                            return inputs['calculated-total-amount']
                        }
                    },
                    width: 120
                },
                {
                    text: this.$t('headers.count'),
                    name: 'count',
                    value: 'count',
                    sortable: false,
					width: '10%'
                },
                {
                    text: 'مدة التسليم',
                    name: 'delivery-period',
                    value: 'delivery_period',
                    sortable: false,
                    width: 130
                },
                {
                    text: '',
                    name: 'hint',
                    noInput: true,
                    value: '',
                    width:50,
                    divider: false
                }

            ]
            return  headers.filter(v => Boolean(v));
        },
        isWarehousePermission() {
            return (this.userTypePermission === userType.warehouseKeeper) || (this.userTypePermission === userType.warehouseManger)
        },
        isAccountantPermission() {
            return (this.userTypePermission === userPermission.accountant 
                        || this.userTypePermission === userPermission.advanceAccountant)
        },

        contextMenuItems() {
            const items = [            {
                    event: 'edit',
                    title: this.$t('InvoiceSalePage.context-menu.edit'),
                }]
                items.push({
                    event: 'delete',
                    title: this.$t('InvoiceSalePage.context-menu.delete'),
                })
            return items;
        },
        currencyNameCreate() {
            if (this.offer_template.alternative_currency_id) {
                return this.$t('change-currency.currency') + ': ' + this.configs.currencies.find(c => c.id === this.offer_template.alternative_currency_id)?.name
            }
            return this.$t('change-currency.currency')
        },
		currencyNameUpdate() {
			if (this.offer_data.alternative_currency_id) {
				return this.$t('change-currency.currency') + ': ' + this.configs.currencies.find(c => c.id === this.offer_data.alternative_currency_id)?.name
			}
			return this.$t('change-currency.currency')
		},

		disableDefaultCurrencyPrice() {
			return Boolean(this.offer_data.alternative_currency_id === this.currentFinancialFile.default_currency_id)
		},

		disableDefaultCurrencyPriceCreate() {
			return Boolean(this.offer_template.alternative_currency_id === this.currentFinancialFile.default_currency_id)
		},

        tradeConfigAccounts() {
            return [
                { 
                    ...(
                        this.getAccountById(this.defaultFinancialFileAccounts.buy_account_id) || {}
                    ),
                    id: null
                },
                ...this.configs.accounts,
            ].filter(c =>
                c.type === type.sub &&
                c.id !== this.defaultFinancialFileAccounts.buy_account_id
            )
        },
        file_is_locked(){ return this.configs?.financial_file?.is_locked },
        materialsFilter() {
            return (warehouseId, type) => warehouseId 
            ?this.materials.filter(v => v.warehouse_id === warehouseId && v.type===type) 
            :this.materials.filter(v => v.type===type)
        },
        showMaterialSpecifications() {
            return this.getSettingByKey('ShowMaterialSpecifications')?.setting_value;
        }
    },
    methods: {
        moment,
        submitOffer(isUpdate = false) {
            const offerPayload = {
                offerType: offerType.sale,
                offerId: this.$route.params.id,
                offerData: {
                    account_id: isUpdate
                        ? this.offer_data.account_id 
                        :this.offer_template.account_id,
                    doc_no : '',
                    date: isUpdate 
                        ? this.offer_data.date
                        : this.offer_template.date,
                    id: this.$route.params.id,
                    notes: isUpdate
                        ? this.offer_data.notes 
                        : this.offer_template.notes,
                    validity_days: isUpdate 
                        ?this.offer_data.validity_days
                        :this.offer_template.validity_days,
                    payment_terms: isUpdate 
                        ?this.offer_data.payment_terms
                        : this.offer_template.payment_terms,
                    alternative_currency_id: isUpdate 
                        ? this.offer_data.alternative_currency_id !== this.configs.financial_file.default_currency_id 
                            ? this.offer_data.alternative_currency_id
                            : null
                        : this.offer_template.alternative_currency_id !== this.configs.financial_file.default_currency_id 
                            ? this.offer_template.alternative_currency_id 
                            : null,
                    currency_price: isUpdate
                        ? this.offer_data.currency_price !== this.configs.financial_file.default_currency_id
                            ? this.offer_data.currency_price 
                            : null
                        : this.offer_template.currency_price !== this.configs.financial_file.default_currency_id
                            ? this.offer_template.currency_price
                            : null,
                    alternative_total_net: isUpdate && this.offer.alternative_currency_id
                        ? {
                            amount: this.offer_data.total_net,
                            currency_id: this.offer_data.alternative_currency_id
                        } 
                        : null
                    , 
                    total_net: isUpdate && !this.offer.alternative_currency_id
                        ? {
                            amount: this.offer_data.total_net,
                            currency_id: this.configs.financial_file.default_currency_id
                        } 
                        : {
                            amount: 0,
                            currency_id: this.configs.financial_file.default_currency_id
                        },
                    alternative_discount_total: isUpdate && this.offer.alternative_currency_id
                        ? {
                            amount: this.offer_data.discount_total || 0,
                            currency_id: this.offer_data.alternative_currency_id
                        } 
                        : null
                    ,
                    discount_total: isUpdate && !this.offer.alternative_currency_id
                        ? {
                            amount: this.offer_data.discount_total || 0,
                            currency_id: this.configs.financial_file.default_currency_id
                        } 
                        : null
                }
            }
            if(isUpdate && this.offer_data.alternative_currency_id && this.offer.alternative_currency_id && this.offer_data.alternative_currency_id !== this.offer.alternative_currency_id && this.offer.alternative_currency_id !== this.configs.financial_file.default_currency_id && this.offer_data.alternative_currency_id !== this.configs.financial_file.default_currency_id) {
                this.changeCurrencyAlertDialog = true
				this.offer_data.alternative_currency_id = this.offer.alternative_currency_id;
				this.recommendCurrencyDefaultPriceUpdate(this.offer_data.alternative_currency_id);
				return null;
            }
            const actionName = isUpdate ? 'update' : 'create';
            if(isUpdate || this.$refs.createForm.validate()) {
                if(!isUpdate) {
                    this.createLoading = true;
                }
                this.$store.dispatch(`offers/${actionName}Offer`, offerPayload).then(() => {
                    this.fetchOffers().then(() => {
                        this.createOfferDialog = false;
                        this.$refs.table.resetInputs();
                        this.tableInputs.warehouseId = this.warehouses.find(c => c.is_default === true)?.id;
                        if(isUpdate) {
                            this.fetchOffer(this.$route.params.id).then(() => {
                                this.currentCurrencyDialog = false;
                                EventBus.$emit("notification", this.$t('PriceOfferPage.price-offer-update'));
                            });
                        } else {
                            this.$router.replace({name: 'price-offer', params: {id:this.offers[this.offers.length - 1]?.id}});
                        }
                        this.createLoading = false;
                    });

                })
            }
        },
        fetchOffers() {
            return this.$store.dispatch('offers/fetchOffers', offerType.sale);
        },
        fetchOffer(id) {
            this.loading = true;
            return this.$store.dispatch('offers/fetchOffer', {offerType: offerType.sale , offerId: id }).then(data => {
                this.offer = data;
                this.offer_data.date = data.date;
                this.offer_data.account_id = data.account_id;
                this.offer_data.alternative_currency_id = data.alternative_currency_id;
                this.offer_data.currency_price = data.currency_price
                this.offer_data.notes = data.notes
                this.offer_no = data.no;
                this.offer_data.status = data.status;
                this.offer_data.validity_days = data.validity_days;
                this.offer_data.payment_terms = data.payment_terms;
                this.offer_data.discount_total = data.alternative_discount_total?.amount || data.discount_total.amount || null;
                this.offer_data.total_net = data.total_net.amount;
                this.offer_data.alternative_total_net = data.alternative_total_net?.amount
                this.offer_data.total_price = 0;
                this.entries = data.price_offer_entries.map(v => {
                        this.offer_data.total_price += v.alternative_calculated_total_amount?.amount || v.calculated_total_amount?.amount || 0;
                        return ({
                            ...v,
                            warehouse_id: this.getMaterialById(v.material_id)?.warehouse_id,
                        })
                }
                )

                this.offer_data.warehouse_id = this.warehouses.find(c => c.is_default === true)?.id;
                this.tableInputs.warehouseId = this.offer_data.warehouse_id;
                this.loading = false;
                return data;
            })
        },
        changeOfferStatus() {
            return this.$store.dispatch('offers/changeOfferStatus', {
                offerType: offerType.sale,
                offerId: this.$route.params.id,
                status: this.offer_data.status
            }).then(() => {
                this.fetchOffer(this.$route.params.id).then(() => {
                    EventBus.$emit("notification", this.$t('PriceOfferPage.price-offer-update'));
                });
            })
        },
        entryHandler() {
            const actionName = this.rowId ? 'update': 'create'; 
            const entry = {
                material_id : this.tableInputs.materialId,
                quantity: {
                    quantity: +this.tableInputs.quantity,
                    unit_size_id: null
                },
                alternative_price: this.offer.alternative_currency_id 
                    ? {
                        amount: this.tableInputs.price,
                        currency_id: this.offer_data.alternative_currency_id
                    }
                    : null,
                price: !this.offer.alternative_currency_id 
                    ? {
                        amount: this.tableInputs.price ,
                        currency_id: this.configs.financial_file.default_currency_id
                    } 
                    : {
                        amount: 0,
                        currency_id: this.configs.financial_file.default_currency_id
                    },
                alternative_discount_total: this.offer.alternative_currency_id 
                    ? {
                        amount: this.tableInputs['discount-amount'] || 0,
                        currency_id: this.offer_data.alternative_currency_id
                    }
                    : null,
                discount_amount: !this.offer.alternative_currency_id 
                    ? {
                        amount: this.tableInputs['discount-amount'] || 0,
                        currency_id: this.configs.financial_file.default_currency_id
                    }
                    : {
                        amount: 0,
                        currency_id: this.configs.financial_file.default_currency_id
                    },
                alternative_calculated_total_amount: this.offer.alternative_currency_id 
                    ? {
                        amount: this.tableInputs['calculated-total-amount'] ||0,
                        currency_id: this.offer_data.alternative_currency_id
                    }
                    : null,
                calculated_total_amount: !this.offer.alternative_currency_id 
                    ? {
                        amount: this.tableInputs['calculated-total-amount'] ||0,
                        currency_id: this.configs.financial_file.default_currency_id
                    } 
                    : {
                        amount: 0,
                        currency_id: this.configs.financial_file.default_currency_id
                    },
                discount_percentage: this.tableInputs['discount-percentage'] || 0,
                delivery_period: this.tableInputs['delivery-period'],
                count: +this.tableInputs.count,
                /*used the notes column as a material specifications*/
                notes: this.tableInputs['material-specifications'],
                doc_no: '',
                date: moment().format('YYYY-MM-DD')
            }
            if(this.$refs.table.validate()) {
                this.$store.dispatch(`offers/${actionName}Entry`, 
                    {
                        offerType:offerType.sale , 
                        entry:entry , 
                        entryId: this.rowId,
                        offerId:this.$route.params.id
                    }).then(() => {

                        this.$refs.table.resetInputs();
                        this.$refs.table.resetEdit();
                        this.$refs.table.resetInputsFocus();
                        this.fetchOffer(this.$route.params.id).then(data => {
                            // console.log(data);
                            if(actionName === 'create') {
                                this.$nextTick(() => {
                                    data.price_offer_entries.length? this.$refs.table.scrollToRow():null;
                                })
                            }
                        });
                        this.rowId = null;
                    })
            }
        },
        deleteEntry() {
            this.loading=true;
            this.$store.dispatch('offers/deleteEntry', {
                offerId: this.$route.params.id,
                entryId: this.rowId,
                offerType: offerType.sale
            }).then(() => {
                this.loading = false
                this.rowId = null;
                this.fetchOffer(this.$route.params.id);
            }).finally(() => this.loading = false)
        },
        deleteOffer(id) {
            this.$store.dispatch('offers/deleteOffer', {offerType: offerType.sale, offerId:id}).then(() => {
                this.fetchOffers().then(() => {
                    const length = this.offers?.length;
                    if(length) {
                        this.deleteDialog = false
                        this.$router.replace({name:'price-offer', params: {id: this.offers[length - 1].id}})
                    } else {
                        /*reset the page*/
                        this.deleteDialog = false;
                        this.offer_no = null;
                        this.offer_data.date = null;
                        this.offer_data.notes = null;
                        this.offer_data.material_id = null;
                        this.offer_data.account_id = null;
                        this.offer_data.warehouse_id = null;
                        this.offer_data.discount_total = null;
                        this.offer_data.total_net = null;
                        this.$router.replace({name:'price-offer'})
                    }
                })
            })
        },
        createReport() {
            return this.$store.dispatch('reports/offerReport', {
                financialFileId: this.currentFinancialFile.id,
                userId: ls.getLocalUser().id,
                offerType: offerType.sale,
                offerId: this.$route.params.id,
                type: 'pdf'
            })
        },
        updateRouteId() {
            let newId = this.getOfferByNo(this.offer_no)?.id
            // console.log(this.order_no)
            if(newId) {
                this.$router.push({name: 'price-offer', params: {id: newId}})
            }
        },

		resetCurrencyDialog() {
			if (this.offer.alternative_currency_id === null) {
				this.offer_data.alternative_currency_id = null
				this.offer_data.currency_price = null
			} else {
                this.offer_data.alternative_currency_id = this.offer.alternative_currency_id
                this.offer_data.currency_price = this.offer.currency_price
			}
		},
		recommendCurrencyPriceCreate(value) {
			if (value === this.currentFinancialFile.default_currency_id) {
				this.offer_template.currency_price = 1
			} else {
				this.offer_template.currency_price = this.configs.currencies.find(e => e.id === value).latest_exchange_record
			}
		},

		recommendCurrencyDefaultPriceUpdate(value) {
			if (value === this.currentFinancialFile.default_currency_id) {
				this.offer_data.currency_price = 1
			} else {
				this.offer_data.currency_price = this.configs.currencies.find(e => e.id === value).latest_exchange_record
			}
		},
		recommendCurrencyPriceUpdate(value) {
			if(this.offer_data.alternative_currency_id === value) {
				this.offer_data.currency_price = this.offer.currency_price
			} else {
				this.offer_data.currency_price = this.configs.currencies.find(e => e.id === value).latest_exchange_record
			}
		},
        recommendDefaultCurrency() {
            if(!this.offer.alternative_currency_id) {
                this.offer_data.alternative_currency_id = this.currentFinancialFile.default_currency_id
                this.offer_data.currency_price = 1;
            }
        },
        recommendDefaultCurrencyCreate() {
            this.offer_template.alternative_currency_id = this.currentFinancialFile.default_currency_id
            this.offer_template.currency_price = 1;
        },
        recommendMaterialData() {
            const material = this.materials.find(c => c.id === this.tableInputs.materialId)
            this.tableInputs.price = material?.sale_price?.amount / (this.offer.currency_price || 1);
            this.tableInputs['material-specifications'] = material?.specifications;
        },
        reset(){
            this.loading = false
            this.offer_template.account_id = null
            this.offer_template.doc_no = null
            this.offer_template.notes = null
            this.offer_template.validity_days = null;
            this.offer_template.payment_terms = null;
            this.offer_template.date = moment().format('YYYY-MM-DD')
            this.createOfferDialog = false
            // this.$refs.form.resetValidation()
            this.offer_template.alternative_currency_id = this.currentFinancialFile.default_currency_id
            this.offer_template.currency_price = 1;
        },
        getNodeMaterials() {
            const data = {
                nodeId : this.offer_data.material_id,
                warehouseId : this.offer_data.warehouse_id
            }
            if(data.nodeId && data.warehouseId) {
                this.$store.dispatch('materials/getNodeMaterials', data).then(data => {
                    this.filteredMaterials = data 
                })
            }
        },
        setWarehouse() {
            this.offer_data.material_id='';
            this.tableInputs.warehouseId = this.offer_data.warehouse_id
        },
        setRowIndexBeforeEdit(index, item) {
            this.rowId = item.id;
            this.$refs.table.activeEditForRow(index);
        },
        resetCreateOfferForm() {
            this.offer_template.account_id = null; this.offer_template.notes = null;this.createOfferDialog = false
        },
    },
    mounted() {
        this.loading = true
        const promises = [
        !this.warehouses.length
            ? this.$store.dispatch('warehouses/fetchAll')
            : null,
        !this.materials.length 
            ? this.$store.dispatch('materials/fetchAll') 
            : null,
        !this.offers.length 
            ?this.fetchOffers()
            :null
        ]
        if (Object.keys(this.configs).length == 0) {
            promises.push(this.$store.dispatch('configs/fetchAll'))
        }
        // if (!this.invoiceCategories.length && useInvoiceCategories) {
        //     promises.push(this.$store.dispatch('invoiceCategories/fetchAll'));
        //     promises.push(this.$store.dispatch('invoiceCategories/fetchDefaultCategories'));
        // }
        Promise.all(promises).then(() => {
            if(this.$route.params.id) {
                this.fetchOffer(this.$route.params.id)
            }else if(this.offers.length) {
                this.$router.replace({name: 'price-offer', params: {id: this.offers[this.offers.length - 1].id}})
            } else {
                this.loading = false;
                this.entries = [];
            }
                this.loading = false;
                this.entries = [];
        }) 

    }
}
</script>
<style>
</style>